// extracted by mini-css-extract-plugin
export default {"container":"department-data-items_container__7Nn5T"};